// import * as uuidLib from 'uuid';

class Section {
  id = '';
  media = '';
  media_desc = '';
  media_type = '';
  title = '';
  content = '';
  url = '';
}

export default Section;
